// Device-aware app store links. On the web we show only the store that
// matches the visitor's device so Apple devices never see Google Play
// (App Store review rejects apps that surface competing store links).

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/the-vent-app/id6757621490';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.ventapp.vent';

export type StoreDevice = 'ios' | 'android' | 'other';

export function getStoreDevice(): StoreDevice {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  // iPadOS 13+ reports as Macintosh but has touch points.
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  if (/Mac OS X|Macintosh/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'other';
}

// Fallback for desktop/other devices: App Store only.
export function getPreferredStoreUrl(): string {
  return getStoreDevice() === 'android' ? PLAY_STORE_URL : APP_STORE_URL;
}

export function shouldShowAppStore(): boolean {
  return getStoreDevice() !== 'android';
}

export function shouldShowPlayStore(): boolean {
  return getStoreDevice() === 'android';
}
